import { useUserContext } from '@/context/user';
import { usePathname, useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';

export const useSignInPage = props => {
  const {
    createAccountPageUrl = '/create-account',
    forgotPasswordPageUrl = '/forgot-password',
    signedInRedirectUrl = '/customer/account',
  } = props;
  const router = useRouter();
  const pathname = usePathname();
  const [{ isSignedIn }] = useUserContext();

  // Redirect if user is signed in
  useEffect(() => {
    if (isSignedIn) {
      if (signedInRedirectUrl && !pathname.includes('/customer/')) {
        router.push(signedInRedirectUrl);
      }
    }
  }, [router, isSignedIn, signedInRedirectUrl, pathname]);

  const handleShowCreateAccount = useCallback(() => {
    if (createAccountPageUrl) {
      router.push(createAccountPageUrl);
    }
  }, [createAccountPageUrl, router]);

  const handleShowForgotPassword = useCallback(() => {
    if (forgotPasswordPageUrl) {
      router.push(forgotPasswordPageUrl);
    }
  }, [forgotPasswordPageUrl, router]);

  const signInProps = {
    classes: {
      modal_active: undefined,
    },
    showCreateAccount: handleShowCreateAccount,
    showForgotPassword: handleShowForgotPassword,
  };

  return {
    signInProps,
  };
};
